module.exports = __webpack_public_path__ + "static/media/home-caro-10.8d819808.png";